import generateUniqueId from 'helpers/generateUniqueId'
import getItemsLocalStorageKey from 'helpers/getItemsLocalStorageKey'
import escapeHtml from 'helpers/escapeHtml'
import {
    SHOPPING_LIST_INITIALIZE_LIST,
    SHOPPING_LIST_CREATE_LIST,
    SHOPPING_LIST_UPDATE_LIST,
    SHOPPING_LIST_CREATE_ITEM,
    SHOPPING_LIST_EDIT_ITEM,
    SHOPPING_LIST_DELETE_ITEM,
    SHOPPING_LIST_CLEAR_ITEMS
} from '../constants/actionTypes'


export const initializeList = (data) => ({
    type: SHOPPING_LIST_INITIALIZE_LIST,
    data
})

export const createList = () => ({
    type: SHOPPING_LIST_CREATE_LIST,
    listId: generateUniqueId()
})

export const updateList = () => ({
    type: SHOPPING_LIST_UPDATE_LIST,
    data: JSON.parse(localStorage.getItem(getItemsLocalStorageKey()))
})

export const createItem = data => (dispatch, getState) => {
    const state = getState()
    const wrapperCurrentUrl = state.wrapper.currentUrl
    const isBacklinkRequired = state.configuration.partner.isBacklinkRequired
    const name = escapeHtml(data.name)

    // if sourceUrl hasn't been provided, we use window url
    const itemData = isBacklinkRequired && wrapperCurrentUrl && !data.sourceUrl
        ? { ...data, name, sourceUrl: wrapperCurrentUrl }
        : data

    dispatch({
        type: SHOPPING_LIST_CREATE_ITEM,
        id: generateUniqueId(),
        data: itemData
    })
}

export const editItem = (id, data) => ({
    type: SHOPPING_LIST_EDIT_ITEM,
    id,
    data: {
        ...data,
        name: escapeHtml(data.name)
    }
})

export const deleteItem = id => ({
    type: SHOPPING_LIST_DELETE_ITEM,
    id
})

export const clearItems = () => ({
    type: SHOPPING_LIST_CLEAR_ITEMS
})
